// extracted by mini-css-extract-plugin
module.exports = {"menu__item":"menu-hashed__menu__item__s1DKn","menu__itemIcon":"menu-hashed__menu__itemIcon__1ebND"};